/* eslint-disable */
declare module '*.st.css';
declare module '*.json';
declare module '*.tsx';
declare module '*.md';
declare module '*.scss';
declare module '*.md';

declare var window: Window &
  typeof globalThis & {
    ResizeObserver: ResizeObserver;
  };

interface ResizeObserver {
  disconnect(): void;
  observe(target: Element, options?: ResizeObserverOptions): void;
  unobserve(target: Element): void;
}

declare var ResizeObserver: {
  prototype: ResizeObserver;
  new (callback: ResizeObserverCallback): ResizeObserver;
};
